import React from 'react';
import PropTypes from 'prop-types';

import {withI18n} from 'spa/Components/Context';

import ProgressiveImage from 'spa/Components/ProgressiveImage';

import {cn} from 'spa/css';

import './press-featured-new.less';

@withI18n
class PressFeaturedFR extends React.Component {
  static propTypes = {
    smallLogos: PropTypes.bool,
  };

  render() {
    const {i18n} = this.context;
    const {smallLogos} = this.props;

    return (
      <div className="press-featured__press-container container">
        <div className="press-featured__press-element press-featured__press-element--mobile-bordered">
          <p className="press-featured__press-img-wrapper">
            <ProgressiveImage
              disableWebp
              className={cn(smallLogos ? 'press-featured__press-image' : 'press-featured__press-image--medium')}
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1493913190/home-fr/elle.svg"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/v1493913190/home-fr/elle.svg"
              alt={i18n._x('Vogue Magazine logo', 'Press image alt text in the homepage')}
            />
          </p>
        </div>
        <div className="press-featured__press-element">
          <p className="press-featured__press-img-wrapper">
            <ProgressiveImage
              disableWebp
              className={cn(smallLogos ? 'press-featured__press-image' : 'press-featured__press-image--medium')}
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1493913190/home-fr/europe1.svg"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/v1493913190/home-fr/europe1.svg"
              alt={i18n._x('The Telegraph Newspaper logo', 'Press image alt text in the homepage')}
            />
          </p>
        </div>
        <div className="press-featured__press-element press-featured__press-element--mobile-bordered press-featured__press-element--mobile-top-bottom-border">
          <p className="press-featured__press-img-wrapper">
            <ProgressiveImage
              disableWebp
              className="press-featured__press-image"
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1493913190/home-fr/lefigaro.svg"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/v1493913190/home-fr/lefigaro.svg"
              alt={i18n._x('The Guardian Newspaper logo', 'Press image alt text in the homepage')}
            />
          </p>
        </div>
        <div className="press-featured__press-element press-featured__press-element--mobile-top-bottom-border">
          <p className="press-featured__press-img-wrapper">
            <ProgressiveImage
              disableWebp
              className={cn(smallLogos ? 'press-featured__press-image' : 'press-featured__press-image--medium')}
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1493913190/home-fr/leparisien.svg"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/v1493913190/home-fr/leparisien.svg"
              alt={i18n._x('Timeout Magazine logo', 'Press image alt text in the homepage')}
            />
          </p>
        </div>
        <div className="press-featured__press-element press-featured__press-element--mobile-bordered">
          <p className="press-featured__press-img-wrapper">
            <ProgressiveImage
              disableWebp
              className={cn(smallLogos ? 'press-featured__press-image' : 'press-featured__press-image--medium')}
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1493913190/home-fr/m6.svg"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/v1493913190/home-fr/m6.svg"
              alt={i18n._x('TechCrunch logo', 'Press image alt text in the homepage')}
            />
          </p>
        </div>
      </div>
    );
  }
}

export default PressFeaturedFR;



// WEBPACK FOOTER //
// ./spa/Pages/Home2020/PressFeaturedFR.jsx